(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kiva-specifications"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kiva-specifications'))
    customElements.define(
      'kiva-specifications',
      class extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          const dialog = this.querySelector('dialog');
          this.querySelector(':scope > button').addEventListener('click', () => dialog.showModal());
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) {
              const r = dialog.getBoundingClientRect();
              if (event.clientX < r.left || event.clientX > r.right) dialog.close();
            }
          });
        }
      }
    );
  } catch(e) { console.error(e); }
})();

})();
